<template>
    <div class="columnContainer box">
        <ul class="list-group list-group-flush">
            <li class="list-group-item list-group-item-secondary"
                style="padding-top: 20px; padding-left: 50px; padding-right: 50px; background-color: rgb(192, 192, 192);">
                <h1>Quizz des noms d'Allah</h1>
                <label for="" style="font-size: large;">Combien de noms connaissez vous ?</label>
            </li>
            <li class="list-group-item list-group-item-secondary">
                <div class="rowContainer">
                    <input label="inputNumber" id="inputNumber" type="number" min="1" max="99" v-model="nombreDeQuestions">
                    <div>
                        <b>Aléatoire</b>
                        <input type="checkbox" class="checkbox" v-model="isRandom">
                    </div>
                </div>
            </li>
            <li class="list-group-item list-group-item-secondary"
                style="padding-top: 20px; padding-bottom: 20px; padding-left: 50px; padding-right: 50px;">
                <router-link :to="urlQuizz">
                    <v-btn type="submit" class="btn btn-primary" @click="updateUrl">Commencer</v-btn>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>

export default {
    name: 'QuizzPrep',
    components: {
    },
    data() {
        return {
            nombreDeQuestions: 1,
            isRandom: false,
            urlQuizz: "quizz/"
        }
    },
    mounted() {
    },
    methods: {
        updateUrl() {
            this.urlQuizz += this.nombreDeQuestions + "/" + this.isRandom
        }
    }
}
</script>

<style scoped>
.columnContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.rowContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
}

#inputNumber {
    width: 50px;
    margin: 10px;
    background-color: rgb(255, 255, 255);
    border-radius: 5px;
}

.box {
    background: linear-gradient(217deg, rgba(255, 0, 0, .8), rgba(255, 0, 0, 0) 70.71%),
        linear-gradient(127deg, rgba(0, 255, 0, .8), rgba(0, 255, 0, 0) 70.71%),
        linear-gradient(336deg, rgba(0, 0, 255, .8), rgba(0, 0, 255, 0) 70.71%);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.list-group {
    border-radius: 20px;
}

.checkbox {
    margin-left: 10px;
    width: 20px;
    height: 20px;
    border-radius: 20px;
    transform: translateY(5px);
}
</style>
